import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NbAccordionModule, NbCardModule, NbIconModule, NbWindowModule, NbActionsModule, NbTooltipModule, NbSearchModule } from '@nebular/theme';

import { LayoutsModule } from '../layouts/layouts.module';
import { SharedModule } from '../shared/shared.module';
import { FaqComponent } from './faq/faq.component';
import { FaqsComponent } from './faqs/faqs.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { SearchTextResultComponent } from './search-text-result/search-text-result.component';
import { SinglePopertyComponent } from './single-poperty/single-poperty.component';
import { NewsComponent } from './news/news.component';
import { NewsCardComponent } from './news-card/news-card.component';
import { NewsDetailsComponent } from './news-details/news-details.component';
import { SoumettreDesirsComponent } from './soumettre-desirs/soumettre-desirs.component';
import { DemenagementComponent } from './demenagement/demenagement.component';
import { DemenagementsComponent } from './demenagements/demenagements.component';
import { DetailsDemenagementComponent } from './details-demenagement/details-demenagement.component';
import { PropertiesComponent } from './properties/properties.component';

@NgModule({
  declarations: [
    FaqComponent,
    FaqsComponent,
    SearchResultComponent,
    SearchTextResultComponent,
    SinglePopertyComponent,
    NewsComponent,
    NewsCardComponent,
    NewsDetailsComponent,
    SoumettreDesirsComponent,
    DemenagementComponent,
    DemenagementsComponent,
    DetailsDemenagementComponent,
    PropertiesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NbAccordionModule,
    NbCardModule,
    NbIconModule,
    NbWindowModule,
    NbActionsModule,
    NbTooltipModule,
    NbSearchModule,
    LayoutsModule,
    SharedModule
  ],
  exports: [
    FaqComponent,
    FaqsComponent,
    SearchResultComponent,
    SearchTextResultComponent,
    SinglePopertyComponent,
    NewsComponent,
    NewsCardComponent,
    NewsDetailsComponent,
    SoumettreDesirsComponent,
    DemenagementComponent,
    DemenagementsComponent,
    DetailsDemenagementComponent,
    PropertiesComponent,
    NbActionsModule,
    NbTooltipModule,
    NbSearchModule
  ]
})
export class PagesModule { } 